export default __webpack_public_path__ + "static/green-36d6591914e6b8c41fa93391d319d09a.png";